import React, { useState } from "react";
import { IconButton, Popover, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

interface IProps {
    text: string;
}

// Replaces the old hover-only, pure-CSS "(i)" tooltip (a `data-tooltip`
// attribute + ::before/::after, toggled on :hover) with a click-triggered
// MUI Popover - works on touch devices too, which the hover-only version
// never did.
export const HintTooltip: React.FC<IProps> = ({ text }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    return (
        <>
            <IconButton
                size="small"
                onClick={(e) => {
                    // This icon sometimes sits inside a field's <label>
                    // (e.g. the Entity Type select's label). Clicking a
                    // <label> also activates its associated control, which
                    // would pop the dropdown open behind the tooltip -
                    // stop that click from reaching the label.
                    e.stopPropagation();
                    e.preventDefault();
                    setAnchorEl(e.currentTarget);
                }}
                aria-label="More info"
                // IconButton's default padding leaves a big gap of empty
                // space on either side of the icon - tight padding here
                // keeps it close to the text it's explaining instead of
                // reading like a few stray spaces.
                sx={{ padding: "2px", verticalAlign: "middle" }}
            >
                <InfoOutlinedIcon fontSize="small" />
            </IconButton>
            <Popover
                open={!!anchorEl}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Typography sx={{ p: 2, maxWidth: 300 }}>{text}</Typography>
            </Popover>
        </>
    );
};

export default HintTooltip;
